import clsx from 'clsx';
import type { InputHTMLAttributes } from 'react';

import styles from './Checkbox.module.scss';

type CheckboxProps = {
  label: string;
  sublabel?: string;
} & Omit<InputHTMLAttributes<HTMLInputElement>, 'type'>;

const Checkbox = ({ label, sublabel, className, id, ...props }: CheckboxProps) => {
  const checkboxId = id || `checkbox-${label.replace(/\s+/g, '-').toLowerCase()}`;

  return (
    <div className={clsx(styles.checkboxWrapper, className)}>
      <input type="checkbox" id={checkboxId} className={styles.checkbox} {...props} />
      <label htmlFor={checkboxId} className={styles.label}>
        <span className={styles.labelText}>{label}</span>
        {sublabel && <span className={styles.sublabel}>{sublabel}</span>}
      </label>
    </div>
  );
};

export default Checkbox;
